import { put } from 'redux-saga/effects';
import { Creators as TeamsActions } from '~/store/ducks/teams'; 
import Sdk from 'api.digitalpages.module.sdk.api';

export function* getTeams(action) {
  try {
    const { 
      routeUid, 
      pageSize = 40,
      season
    } = action.payload || {};

    const data = yield Sdk.Api.news.getNoticesByRoute(routeUid, {
      pageSize,
      filter: `(season:${season.selected})`,
    });

    yield put(TeamsActions.getSuccess(data));
  } catch (err) {}
}
